import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactsService } from 'src/app/applicationModules/company/services/contacts.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FileManagerService } from '../services/fileManager.services';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'associate-contact-role-filemanager',
  templateUrl: './associate-contact-role-filemanager.component.html',
  styleUrls: ['./associate-contact-role-filemanager.component.scss']
})
export class AssociateContactRoleFileManagerComponent implements OnInit {
@Input() datalist:any=[]; 
@Input() companyID:number; 
@Input() formFolderID:number; 
@Input() typeId:number; 

showAddContact:boolean = false;
isSharedAccessRolePopup:boolean=false;
Module:string;
@Output() showContactDetail = new EventEmitter<boolean>();
currentUser: any;
databaseId: string;
organizationId: string;
responseHolder: any;
contactsList: any=[];
isShare:boolean=false;
showAddButton = false;
spinner:boolean=false;
searchName:string='';
isRolePopup: boolean=false;
Roles: any=[]; 
sharedAccessRoleList: any=[];
showDetail: boolean = false;
peoples :any=[];  
mainModuleName:string="";
selectedsharedAccessRole : any=[];
action: any;
actionTypeArray: string[];
OfficeIDList: any=[];
myOfficeID: any;
ContactName:string="";
showRoleMessage:boolean=false;
sharedList :any=[]=[]; 

constructor(@Inject(MAT_DIALOG_DATA) public data: any,private fileManagerService: FileManagerService,
  private statusConst: StatusConstant, private loaderService: LoaderService, private contactsService: ContactsService,
  private toastr: ToastrService,private filteredContactVm:FilteredContactVm,
  private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
  private dialog: MatDialog, private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService,
  public dialogRef: MatDialogRef<AssociateContactRoleFileManagerComponent>) {

  const encryptedtoken = sessionStorage.getItem('userToken');
  this.databaseId = sessionStorage.getItem('databaseId');
  this.organizationId = sessionStorage.getItem('organizationID');
  const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
  this.currentUser = jwt_decode(token);
  var offices=JSON.parse(sessionStorage.getItem('officeList'));
  offices.forEach(oe => {
  this.OfficeIDList.push(oe.officeID)	
  if(oe.isMyoffice==true)
    this.myOfficeID=oe.officeID;
  });  
}

ngAfterContentChecked(){
  this.cdr.detectChanges();
}

ngOnInit(): void {
  var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules")); 
  var contName =[];
  contName = menuModulesList.filter(x => x.mainModuleName == 'Contact');
  if(contName.length>0){
    this.ContactName = contName[0].orgModuleName; 
  }   
  this.showAddButton=false;
  this.getSharedContactRoleList();
}

async getSharedContactRoleList(){
  var FormFolderId;
  var typeId=0;
  var isFile= Object.values(this.data)[3];  
   // 1 for Folder , 2 for File
  if(isFile ==false){
    typeId=1;
    FormFolderId = Object.values(this.data)[1];
  }
  if(isFile ==true){
    typeId=2;
    FormFolderId =Object.values(this.data)[2];
  }
  var ReqModel={
    nameFieldID:0,
    emailFieldID:0,
    itemID:FormFolderId,
    itemType:typeId,
    pageIndex:0,
    pageSize:0,
    userID:this.currentUser.UID,
    organizationID:Number(this.organizationId),
    databaseID:Number(this.databaseId),   
    officeID:this.myOfficeID
  }    
  const result = await this.fileManagerService.GetAllFileFolderSharedTo(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {    
    this.responseHolder = result.data.fileSharedToList;
    if(this.responseHolder !=null){
      this.sharedList = this.responseHolder;
      this.sharedList.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
        if(e.imageUrl==null){
          e.imageUrl="";
        }
        if(e.shareToType==4){          
          e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name);
          e.shortName = e.name.match(/\b(\w)/g).join('');
        }
      });
    }else{
      this.sharedList=[];
    }      
  }
  else {
    this.sharedList=[];
  } 
}

addNew(module){
  this.Module = module;
  this.showAddContact = true;
}


getCloseDetails(message){
  this.showDetail = false;
}

getContactListCoreImplementation(searchValue:any) {
 this.filteredContactVm.DatabaseID = Number(this.databaseId);
 this.filteredContactVm.OrganizationID = Number(this.organizationId);
 this.filteredContactVm.UserID = this.currentUser.UID;
 this.filteredContactVm.searchValue=searchValue;
 this.searchName = searchValue;
 if(this.data.isFile==false){
  this.filteredContactVm.fileManagerItemID=this.data.FileFolderID;
 }
 if(this.data.isFile==true){
  this.filteredContactVm.fileManagerItemID=this.data.FileID;
 }
 this.filteredContactVm.PageSize=0;
 this.contactsService.GetContactListCoreImplementation(this.filteredContactVm).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.contactsList = response.data.contactListModel;
       this.contactsList.forEach(e => {
        e.shortName=e.name.match(/\b(\w)/g).join('');
      });
      this.contactsList.push(
        {
          "contactID":0,
          "companyID":0,
          "name":"Create New",
          "email":"",
          "imageUrl":"",
          "isShared":this.isShare,
          "coreContactUserMapID":0,
          "trasactionalRoleIds":[],
          "contactCoreRoleMappingModels":[],
          "shortName":"CN"
        }
      )    
     }
   }
 });
}


actionSelected(action,actionType,shareToID){
 this.peoples.find(m=>m.shareToID==shareToID).actionType=actionType;
}


actionRoleSelected(action,actionType,shareToID){
   this.selectedsharedAccessRole.find(m=>m.shareToID==shareToID).actionType=actionType;
}

getActionType(actionType){
  if(actionType==-1)
  return this.actionTypeArray= ["Remove"];
  if(actionType==0)
  return this.actionTypeArray= ["Viewer"];
  if(actionType==1)
  return this.actionTypeArray= ["Editor"]
}

contactSelected(contactSelected:any){
  if(contactSelected.contactID == 0) { 
  this.dialog.getDialogById("addContactOrRoleDialog").close();
  this._dataSharingService.SendCurrentFormContactFileManager(contactSelected.currentValue==''?'Create New':contactSelected.currentValue); 
  return ;
 }  

 let contact= this.peoples.find(m=>m.shareToID == contactSelected.contactID);
 
 if(contact == undefined || contact=='' || contact == null){ 
  this.peoples.push({
    name : contactSelected.name,
    email: contactSelected.email,
    img: contactSelected.imageUrl, 
    shortName:contactSelected.shortName,
    shareToID: contactSelected.contactID,
    shareToType: 1,
    actionType: 0 
  });
  if(this.peoples.length > 0){
    this.showAddButton=true;
  }
  else{
    this.showAddButton=false;
  } 
 } 
}


FormFolderContactRoleUpdate(){
   this.showAddButton=false;
   this.data;
   var isFile= this.data.isFile; 
   //if(this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole.length > 0:this.peoples.length > 0) { 
      this.spinner=true;
      var id=0;
      if(isFile==false){
        id=this.data.FileFolderID;
      }
      if(isFile==true){
        id=this.data.FileID;
      }
      var shareTo:any=[];

      if(this.selectedContact==true){
        shareTo=this.peoples;
      }

      if(this.selectedRole==true){
        shareTo=this.selectedsharedAccessRole;
      }
      if(this.selectedUser==true){
        shareTo=this.userSelectedList;
      }

      let ReqModel ={
       shareTo : shareTo,
       //shareTo : this.isSharedAccessRolePopup==true? this.selectedsharedAccessRole:this.peoples,
       UserID : this.currentUser.UID,
       DatabaseID : Number(this.databaseId),
       OrganizationID : Number(this.organizationId),
       id: id,
       officeID:this.myOfficeID
       }      
       this.fileManagerService.ShareFileFolder(ReqModel).subscribe(response => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             if(isFile==false){
              this.toastr.success('Folder shared successfully.', '', {
                timeOut: 3000,
              });
             }
             if(isFile==true){
              this.toastr.success('File shared successfully.', '', {
                timeOut: 3000,
              });
             }
             this.spinner=false;
             this.loaderService.hide();
             this.dialog.closeAll();
             this.dialogRef.close('Added');
             this._dataSharingService.sendRefreshDetailsSharedRoleListForFileManager(true); 
           }
           else {
             this.spinner=false;
             this.loaderService.hide();
             this.dialog.closeAll();
           }
         }
       });
    // } else {
    //   this.spinner=false;
    //   this.loaderService.hide();
    //   this.dialog.closeAll();
    // }  
}


removeRoles(item:any,isRolePopup:boolean){
  if(isRolePopup){
  const index = this.selectedsharedAccessRole.indexOf(item);
  if (index >= 0) {
    this.selectedsharedAccessRole.splice(index, 1);
   }
  }   
  if(this.selectedsharedAccessRole.length > 0){
    this.showAddButton=true;
  }
  if(this.selectedsharedAccessRole.length == 0){
    this.showAddButton=false;
  }
}

removeItemContact(item:any,isRolePopup:boolean){
  if(!isRolePopup){  
  const index = this.peoples.indexOf(item);
  if (index >= 0) {
    this.peoples.splice(index, 1);
   }
  }
  if(this.peoples.length == 0){
    this.showAddButton =false;
  }
  if(this.peoples.length > 0){
    this.showAddButton=true;
  }  
}


close() {
  this.peoples=[];  
  this.Roles=[];
  this.selectedsharedAccessRole=[];
  this.showAddButton=false;
  this.dialog.closeAll();
}

getSharedAccessRoles(searchValue:any) {
  var fileManagerItemID;
  if(this.data.isFile==false){
    fileManagerItemID=this.data.FileFolderID;
   }
   if(this.data.isFile==true){
    fileManagerItemID=this.data.FileID;
   }
   var ReqModel={
   DatabaseID : Number(this.databaseId),
   OrganizationID: Number(this.organizationId),
   UserID : this.currentUser.UID,
   fileManagerItemID: fileManagerItemID,  
   searchValue:searchValue
  }
  if(searchValue==""){
   this.showRoleMessage=false;
  }  
  this.contactsService.getSharedAccessRoles(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.fileManagerService.GetAllFileFolderSharedRole(ReqModel).subscribe(response1 => {
          if (response1 != undefined) {
            if (response1.status == this.statusConst.statusSuccess) {
              this.sharedAccessRoleList = response.data;
              let roleIdListForFormOrFolder=response1.data;
              this.sharedAccessRoleList=this.sharedAccessRoleList.filter(m=>!roleIdListForFormOrFolder.includes(m.roleID))
              if(this.sharedAccessRoleList.length==0 && !this.showRoleMessage && searchValue!="") {
                this.showRoleMessage=true;
                this.toastr.info('No role left to assign, contact to administrator.', '', {
                timeOut: 3000,
              });
              }else{
                
              }
           }
         }
        });
      }
    }
  });
}

RoleSelectedForSharedAccess(roleSelected:any){
  let role= this.selectedsharedAccessRole.find(m=>m.shareToID == roleSelected.roleID); 
  if(roleSelected.roleID == 0) {  
   let newRole = this.selectedsharedAccessRole.find(m=>m.name.toLowerCase() == roleSelected.name.toLowerCase());
   if(newRole == undefined) { 
     this.selectedsharedAccessRole.push({      
        name : roleSelected.roleName,
        email: '',
        img: '', 
        isShared:this.isShare,
        shortName:'',
        shareToID: roleSelected.roleID,
        shareToType: 2,
        actionType: 0 
      });
      if(this.selectedsharedAccessRole.length > 0){
        this.showAddButton=true;
      }
      if(this.selectedsharedAccessRole.length == 0){
        this.showAddButton=false;
      }
    }
    return;
  }
  
  if(role == undefined || role == '' || role == null) { 
    this.selectedsharedAccessRole.push({      
      name : roleSelected.roleName,
      email: '',
      img: '', 
      isShared:this.isShare,
      shortName:'',
      shareToID: roleSelected.roleID,
      shareToType: 2,
      actionType: 0 
   });
  } 

  if(this.selectedsharedAccessRole.length > 0){
    this.showAddButton=true;
  }
  if(this.selectedsharedAccessRole.length == 0){
    this.showAddButton=false;
  }
}

isSharedAccessUserPopup:boolean=false;
userSelectedList:any=[]=[];
sharedAccessUserList: any=[];
timeout = null;
//stateCtrl = new FormControl();
selectedContact:boolean=true;
selectedRole:boolean=false;
selectedUser:boolean=false;

selectSharedAccessRb(value){
   // Role
  if(value == 2){
    this.selectedContact=false;
    this.selectedRole=true;
    this.selectedUser=false;
    this.isSharedAccessRolePopup=true;
    this.peoples=[];
    this.selectedsharedAccessRole=[];
    this.showAddButton =false;
    this.isSharedAccessUserPopup=false;
    this.userSelectedList=[];
  }
  // Contact
  if(value == 1){
    this.selectedContact=true;
    this.selectedRole=false;
    this.selectedUser=false;
    this.isSharedAccessRolePopup=false;
    this.peoples=[];
    this.selectedsharedAccessRole=[];
    this.showAddButton =false;
    this.isSharedAccessUserPopup=false;
    this.userSelectedList=[];
  }
  // User
  if(value == 3){
    this.selectedContact=false;
    this.selectedRole=false;
    this.selectedUser=true;
    this.isSharedAccessRolePopup=false;
    this.isSharedAccessUserPopup=true;
    this.peoples=[];
    this.selectedsharedAccessRole=[];
    this.userSelectedList=[];
    this.showAddButton =false;
  }
  }


  searchUser(val) {
    if (val.length >= 2) {
      this.sharedAccessUserList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.sharedAccessUserList = [];
      }
    }
  }

  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.sharedAccessUserList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.contactsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessUserList = response.data.userModel;
          this.sharedAccessUserList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.sharedAccessUserList = this.sharedAccessUserList;
        }
      }
    });
  }

  userSelected(userSelected: any) {
    //this.stateCtrl.setValue('');
    var user=[];
    user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
    if (user.length==0) {
      // var isOwner=false;
      // if(this.isAddOwner==true){
      //   isOwner=true;
      // }else{
      //   isOwner=false;
      // }
  
      // if(this.isAddOwner==false){
      //   var users=[];
      //   users = this.SharedContacts.filter(m => m.userID == userSelected.userID);
      //   if(users.length>0){
      //     this.toastr.warning('User allready added in shared access list.', '', {
      //       timeOut: 3000,
      //     });
      //     if(this.userSelectedList.length > 0){
      //       this.showAddButton=true;
      //     }
      //     else{
      //       this.showAddButton=false;
      //     } 
      //     return;
      //   }     
      // }
     
      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');
  
      this.userSelectedList.push({
         name: userSelected.firstName + " " + userSelected.lastName,      
         email: userSelected.email,        
         userID: userSelected.userID,      
         img: "",
         shortName:shortName,
         sharedUserID:userSelected.uuid,
         shareToType:4,
         actionType: 0    
      });   
      
    }else{
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if(this.userSelectedList.length > 0){
      this.showAddButton=true;
    }
    else{
      this.showAddButton=false;
    } 
  }

  removeUser(item: any) {
    const index = this.userSelectedList.indexOf(item);
    if (index >= 0) {
      this.userSelectedList.splice(index, 1);   
    }
    if(this.userSelectedList.length == 0){
      this.showAddButton =false;
    }
  }

  showUpdateButton:boolean=false;
  sharedContactRoleLists:any=[]=[];
  spinner1:boolean=false;

  actionSelectedShared(action,actionType,shareToID){
    this.sharedList.find(m=>m.shareToID==shareToID).permission=actionType;
    var data =  this.sharedList.filter(m=>m.shareToID==shareToID);   
    for (var user = 0; user < data.length; user++) {
     var ReqModel = {
       shareID: data[user].shareID,
       shareToID: data[user].shareToID,
       shareToType: data[user].shareToType,
       actionType: data[user].permission
       }
       this.sharedContactRoleLists.push(ReqModel);
     }
     if(this.sharedContactRoleLists.length > 0){
       this.showUpdateButton=true;
     } else{
       this.showUpdateButton=false;
     }
   }

  FormFolderSharedContactRoleUpdate(){
    this.spinner1=true;
    this.showUpdateButton=false;
    var FormFolderId;
    var isFile= Object.values(this.data)[3];  
     // 1 for Folder , 2 for File
    if(isFile ==false){ 
      FormFolderId = Object.values(this.data)[1];
    }
    if(isFile ==true){
      FormFolderId =Object.values(this.data)[2];
    }  
     if(this.sharedContactRoleLists.length > 0) { 
        let ReqModel = {
         id: FormFolderId,
         userID : this.currentUser.UID,
         shareTo : this.sharedContactRoleLists,
         organizationID : Number(this.organizationId),
         databaseID : Number(this.databaseId),
         officeID:this.myOfficeID
         }
         this.fileManagerService.ModifyShareFileFolder(ReqModel).subscribe(response => {
           if (response != undefined) {
            this.spinner1=false;
             this.responseHolder = response;
             if (this.responseHolder.status == this.statusConst.statusSuccess) {
               this.toastr.success('Record updated successfully.', '', {
                 timeOut: 3000,
               });
               this.loaderService.hide();
               this.close();
              // this._dataSharingService.sendRefreshDetailsSharedRoleListForFileManager(true); 
             }else {
               this.loaderService.hide();
               this.close();
             }
           }else{
            this.spinner1=false;
           }
         });
       } else {
           this.loaderService.hide();
           this.spinner1=false;
           this.close();
      }  
  }

// selectSharedAccessRb(value){
// if(value == 2){
//   this.isSharedAccessRolePopup=true;
//   this.peoples=[];
//   this.selectedsharedAccessRole=[];
//   this.showAddButton =false;
// }
// else{
//   this.isSharedAccessRolePopup=false;
//   this.peoples=[];
//   this.selectedsharedAccessRole=[];
//   this.showAddButton =false;
//  }
 
// }

}
